import styles from './button.module.css';

export const buttonStyles = {
  base: styles.button,
  loading: styles.loading,
  primary: `${styles.button} ${styles.medium} ${styles.primary}`,
  secondary: `${styles.button} ${styles.medium} ${styles.secondary}`,
  secondaryLarge: `${styles.button} ${styles.large} ${styles.secondary}`,
  tertiary: `${styles.button} ${styles.medium} ${styles.tertiary}`,
};
